module.exports = __webpack_public_path__ + "img/entrance-bg.99b48c37.jpg";